import { Box } from '../../Layout/Box';
import { Typography } from '../../Typography';

export interface FormSectionHeaderProps {
  /** Section label — caller passes pre-translated string */
  label: string;
  /** When true renders as display:none (keeps DOM node for a11y announcements) */
  hidden?: boolean;
  'data-testid'?: string;
}

export const FormSectionHeader = ({
  label,
  hidden = false,
  'data-testid': testId,
}: FormSectionHeaderProps) => (
  <Box
    role="heading"
    aria-level={2}
    data-testid={testId}
    sx={{
      display: hidden ? 'none' : 'block',
      borderBottom: '2px solid',
      borderColor: 'secondary.main',
      pb: 0.5,
      mb: 1.5,
    }}
  >
    <Typography variant="h2" sx={{ color: 'secondary.main' }}>
      {label}
    </Typography>
  </Box>
);

FormSectionHeader.displayName = 'FormSectionHeader';
